/* eslint-disable @typescript-eslint/no-unsafe-call */
import { Theme } from '@mui/material';
import { styled } from '@mui/material/styles';

const CARD_WIDTH = '284px';

export const StyledCard = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderTop: `5px solid ${theme.palette.primary.main}`,
  borderRadius: '0px 0px 12px 12px',
  color: theme.palette.common.black,
  marginBottom: theme.spacing(7),
  minHeight: '385px',
  maxWidth: CARD_WIDTH,
  position: 'relative',
  textAlign: 'left',
  width: '100%',
  boxShadow: `0px 8px 24px -4px ${theme.palette.divider}`,
  transition: 'box-shadow 0.5s',

  '&:hover': {
    boxShadow: `0px 8px 32px -4px ${theme.palette.divider}`,
  },
}));

export const StyledEmployerLogo = styled('img')(() => ({
  aspectRatio: '14/10',
  margin: 'auto',
  objectFit: 'cover',
  width: '100%',
}));

export const sxStyles = {
  logoCover: {
    height: '202px',
    width: CARD_WIDTH,
  },
  title: {
    fontSize: '1.5rem',
  },
  detailNote: {
    color: 'rgba(0, 0, 0, 0.6)',
  },
  boxPadding: {
    padding: '16px 20px',
  },
  icon: {
    fill: (theme: Theme) => theme.palette.primary.main,
  },
  buttonsContainer: {
    padding: '1rem',
  },
  favoriteBtn: (theme: Theme) => ({
    width: '100%',
    padding: '0.75rem',
    borderRadius: '40px',
    color: theme.palette.primary.main,

    '&:hover': {
      background: theme.palette.grey[100],
    },
  }),
};

export const StyledContainerLink = styled('a')(() => ({
  textDecoration: 'none',

  '&:hover': {
    cursor: 'pointer',
  },
}));
